import { GameCenterDayGameIdPage } from '@sorare/gameplay/src/pages/game-center/GameCenterDayGameIdPage';

import type { PageParams } from './__generated__/routeParams';

const ScoutingCenterDayGameIdPage = () => {
  return <GameCenterDayGameIdPage<PageParams> />;
};

export default ScoutingCenterDayGameIdPage;
